import "./styles/styles.css";
import "./styles/experiments.css";
import "./styles/brand.css";
import "./styles/responsive.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "../pages/LoginPage.js";
import SeriesPage from "../pages/SeriesPage.js";
import RequireAuth from "./Authentication/RequireAuth.js";
import LogoutPage from "../pages/LogoutPage.js";
import GetStartedPage from "../pages/GetStartedPage.js";
import AboutPage from "../pages/AboutPage.js";
import TestingPage from "../pages/TestingPage.js";
import GamePage from "../pages/GamePage.js";
import MainPage from "../pages/MainPage.js";
import TvGridPage from "../pages/TvGridPage.js"

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route 
            index 
            element={
              <RequireAuth>
                <MainPage />
              </RequireAuth>
            } />
          <Route 
            path="/series" 
             element={
              <RequireAuth>
                <SeriesPage />
              </RequireAuth>
            } />
          <Route 
            path="/login" 
            element={
              <LoginPage />
            } />
          <Route 
            path="/logout" 
            element={
              <LogoutPage />
            } />
          <Route 
            path="/testing" 
            element={
              <TestingPage />
          } />
          <Route 
            path="/getstarted" 
            element={
              <GetStartedPage />
          } />
          <Route 
            path="/about" 
            element={
              <AboutPage />
          } />
          <Route 
            path="/showoftheday" 
            element={
              <RequireAuth>
                <GamePage />
              </RequireAuth>
          } />
          <Route 
            path="/tvgrid" 
            element={
              <RequireAuth>
                <TvGridPage />
              </RequireAuth> 
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
